import {LinkTo} from "../constants/linkTo";

export const isCourseMainPage = (location: any) => {
    if (location.pathname === LinkTo.myCourses) return true;
    if (!location.pathname.startsWith(LinkTo.coursePageWithoutId)) return false;
    const courseId = location.pathname?.slice(LinkTo.coursePageWithoutId?.length + 1)
    return !['my', 'schedule', 'homework', 'groups'].includes(courseId)
}import {LinkTo} from "../constants/linkTo";

export const isCourseMainPage = (location: any) => {
    if (location.pathname === LinkTo.myCourses) return true;
    if (!location.pathname.startsWith(LinkTo.coursePageWithoutId)) return false;
    const courseId = location.pathname?.slice(LinkTo.coursePageWithoutId?.length + 1)
    return !['my', 'schedule', 'homework', 'groups'].includes(courseId)
}